import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { INTEGRATION_REQUEST_INFO_FRAGMENT } from './schema';

const QUERY = gql`
  query IntegrationAuthorizationRequestInfo(
    $dataSource: PerformanceCenterDataSource!
    $customerId: ID
  ) {
    integrationAuthorizationRequestInfo(dataSource: $dataSource, customerId: $customerId) {
      ...IntegrationAuthorizationRequestInfo
    }
  }
  ${INTEGRATION_REQUEST_INFO_FRAGMENT}
`;

export const queryIntegrationAuthorizationRequestInfo = (dataSource, customerId) => {
  return executeGqlQuery({
    variables: { dataSource, customerId },
    query: QUERY,
  }).then(({ data }) => getSingleProp(data));
};
